<smw-icon [icon]="icon()" />
